export default __webpack_public_path__ + "static/media/green-up-arrow.81799947.svg";